import { createFileRoute } from '@tanstack/react-router';
import { SettingsPage } from '../../../components/portals/settings/SettingsPage';

export const Route = createFileRoute('/portal/managers/settings')({
  component: SettingsPage,
});
